/**
 * FloatScrollParallax
 * Wraps each .anima-float-1 / .anima-float-2 in a scroll-wrapper div.
 * Scroll parallax is applied via `transform` on the wrapper.
 * CSS keyframe animation runs on the blob element (separate DOM node — no conflict).
 * Transition on wrapper gives the smooth lag effect when scrolling.
 */
export default class FloatScrollParallax {
  constructor() {
    this.elements = []
    this.scrollPosition = 0
    this.ticking = false
    // float-1 drifts down with scroll, float-2 drifts up (opposite = depth)
    this.speeds = {
      'anima-float-1': 0.18,
      'anima-float-2': -0.13,
    }
  }

  init() {
    this.wrapElements()
    if (this.elements.length === 0) return

    this.updateParallax()

    $(window).on('scroll', () => {
      this.scrollPosition = $(window).scrollTop()
      this.requestTick()
    })

    $(window).on('resize', () => {
      this.updateParallax()
    })
  }

  wrapElements() {
    document.querySelectorAll('.anima-float-1, .anima-float-2').forEach((blob) => {
      // Skip if already wrapped
      if (blob.parentElement.classList.contains('anima-float-scroll-wrapper')) {
        const wrapper = blob.parentElement
        const section = wrapper.closest('section') || wrapper.parentElement
        const className = blob.classList.contains('anima-float-1') ? 'anima-float-1' : 'anima-float-2'
        this.elements.push({ wrapper, section, className })
        return
      }

      const wrapper = document.createElement('div')
      wrapper.className = 'anima-float-scroll-wrapper'
      blob.parentNode.insertBefore(wrapper, blob)
      wrapper.appendChild(blob)

      const section = wrapper.closest('section') || wrapper.parentElement
      const className = blob.classList.contains('anima-float-1') ? 'anima-float-1' : 'anima-float-2'
      this.elements.push({ wrapper, section, className })
    })
  }

  requestTick() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateParallax()
        this.ticking = false
      })
      this.ticking = true
    }
  }

  updateParallax() {
    if ($(window).width() <= 767) {
      this.elements.forEach(({ wrapper }) => { wrapper.style.transform = '' })
      return
    }

    const windowHeight = $(window).height()
    const scrollTop = this.scrollPosition || $(window).scrollTop()

    this.elements.forEach(({ wrapper, section, className }) => {
      const sectionTop = section.getBoundingClientRect().top + scrollTop
      const sectionHeight = section.offsetHeight

      const scrollIntoSection = scrollTop - (sectionTop - windowHeight)

      if (scrollIntoSection < -windowHeight || scrollIntoSection > sectionHeight + windowHeight) {
        return
      }

      const speed = this.speeds[className]
      const offset = scrollIntoSection * speed

      wrapper.style.transform = `translateY(${offset.toFixed(2)}px)`
    })
  }
}

new FloatScrollParallax().init()
